import React from 'react';
import i18n from 'i18n-js';

import Button from '@styles/buttons';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import TenantStatusLayout from '@components/tenantStatus/common/TenantStatusLayout';
import { useManageOnHold } from './hooks/useManageOnHold';

const OnHold = () => {
  const { onLogOut, onSettingsPress } = useManageOnHold();

  const settingsButton = (
    <Button
      variant="Dialog M"
      type="Tertiary"
      onPress={onSettingsPress}
      testID={TEST_IDS.tenantStatus.onHold.settingsButton}
    >
      {i18n.t('Settings')}
    </Button>
  );

  return (
    <TenantStatusLayout
      title={i18n.t('Welcome to Smart Factory.')}
      body={i18n.t("We're setting up your account and will message you when you can start.")}
      primaryAction={settingsButton}
      onLogOut={onLogOut}
      testID={TEST_IDS.tenantStatus.onHold.container}
      logOutTestID={TEST_IDS.tenantStatus.onHold.logOutButton}
    />
  );
};

export default OnHold;
